import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'together-page-content-dynamic',
    templateUrl: './dip.fatalerror.component.html',
    standalone: false
})
export class TogetherAuctionDIPFatalErrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
